<div class="modal-dialog" [ngClass]="{'modal-fullscreen-custom': isFullscreen}">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header d-flex justify-content-between align-items-center">
      <h5 class="modal-title">პოსტის რედაქტირება</h5>
      <div class="d-flex gap-2">
        <!-- Fullscreen Toggle -->
        <button type="button"
                class="btn btn-sm"
                (click)="toggleFullscreen()">
          ⛶
        </button>
        <!-- Close -->
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeModal.emit()"></button>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="pageForm">
      
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            formControlName="title"
            id="title"
            placeholder="სათაური"
            required>
          <label for="title">სათაური</label>
          <div class="invalid-feedback">
            error
          </div>
        </div>

        <div class="form-floating mb-3">
            <select formControlName="menu_page" class="form-select" >
              <option *ngFor="let itm of selectedItems" [value]="itm.menu_page">
              {{ itm.menu?.title || itm.title }} 
              </option>
            </select>
            <label for="menuid">მენიუ</label>
        </div>
      

          <div class="form-floating mb-3">
            <input
              type="datetime-local"
              class="form-control"
              formControlName="add_date"
              id="add_date"
              placeholder="თარიღი"
              required>
            <label for="add_date">თარიღი</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>

          <editor
            *ngIf="!isCat"
            [init]="{
              base_url: '/tinymce',
              license_key: 'gpl',
              suffix: '.min',
              plugins: 'link image fullscreen table lists code preview media wordcount',
              toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image media | code preview | fullscreen',
              file_picker_callback: openFileManagerWrapper
            }"
            formControlName="content"
          ></editor>

    <div class="d-flex flex-wrap gap-4 mt-2 mb-3">

      <!-- ბოლდი -->
      <div class="form-check">
        <input type="checkbox"
              class="form-check-input"
              id="bold"
              formControlName="bold"
              [checked]="pageForm.get('bold')?.value == 1"
              (change)="onCheckboxChange('bold', $event)">
        <label class="form-check-label" for="bold">
          ბოლდი
        </label>
      </div>

      <!-- ფოტოგალერეა -->
      <div class="form-check">
        <input type="checkbox"
              class="form-check-input"
              id="photogallery"
              formControlName="photogallery"
              [checked]="pageForm.get('photogallery')?.value == 1"
              (change)="onCheckboxChange('photogallery', $event)">
        <label class="form-check-label" for="photogallery">
          ფოტოგალერეა
        </label>
      </div>

      <!-- გამოჩენა (Only Gallery) -->
      <div class="form-check">
        <input type="checkbox"
              class="form-check-input"
              id="only_gallery"
              formControlName="only_gallery"
              [checked]="pageForm.get('only_gallery')?.value == 1"
              (change)="onCheckboxChange('only_gallery', $event)">
        <label class="form-check-label" for="only_gallery">
          გამოჩენა
        </label>
      </div>

    </div>

          <div class="mt-3 mb-3">
            <app-upload [uploadPath]="'images/imeages/'"></app-upload>
          </div>

          <div *ngIf="pageForm.get('gallery')?.value?.length" class="mt-3 mb-3">
            <label class="form-label mb-2">არჩეული გალერიის სურათები</label>
              <div
                cdkDropList
                [cdkDropListData]="pageForm.get('gallery')?.value"
                (cdkDropListDropped)="dropGalleryImage($event)"
                class="d-flex flex-wrap gap-3"
                  cdkDropListSortingDisabled="false"
              >
              <div
                class="gallery-image-preview position-relative"
                *ngFor="let img of pageForm.get('gallery')?.value; let i = index"
                cdkDrag
              >
                <img [src]="getFullImageUrl(img)" class="img-thumbnail" width="150" />
                <span
                  class="delete position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  (click)="removeGalleryImage(i)">
                  <i class="fi fi-rr-trash"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="mt-3 mb-3">
              <button type="button" class="btn btn-outline-secondary" *ngIf="!isCat" (click)="openMetaFormModal()">მეტა მონაცემები</button>
          </div>
    


      </form>
    <div class="modal-footer d-flex justify-content-between">
      <div>
        <span *ngIf="pageForm.get('author')?.value"><b>ავტორი: </b>{{pageForm.get('author')?.value}}</span>
      </div>
      <div>
        <button type="button" class="btn btn-secondary mx-1" (click)="closeModal.emit()">დახურვა</button>
        <button type="button" class="btn btn-primary" (click)="savePage()" [disabled]="loadSave">
          <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span> 
          <span *ngIf="!this.editingPageId">დამატება</span>
          <span *ngIf="this.editingPageId">შენახვა</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #fileManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ფაილის არჩევა</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-file-manager
      [type]="'image'"
      [allowedFiles]="allowedFiles"
      (fileSelected)="onFileSelectedFromManager($event, modal)">
    </app-file-manager>
  </div>
</ng-template> -->

<ng-template #metaFormModal let-modal>
  <app-meta-form-modal
    [meta_desc]="pageForm.get('meta_desc')?.value"
    [meta_keys]="pageForm.get('meta_keys')?.value"
    (save)="pageForm.patchValue($event); modal.close()"
  ></app-meta-form-modal>
</ng-template>